import { Translate } from '@src/i18n/useTranslate';

import { z } from 'zod';

export const schema = (t: Translate['i18n']) => {
  const requiredMessage = t('direct_link_required_field');

  const requiredStringField = z.string({ required_error: requiredMessage }).nonempty({ message: requiredMessage });

  return z
    .object({
      email: requiredStringField,
    })
    .transform((data) => {
      return {
        email: data.email,
      };
    });
};
